import { useTranslation } from 'react-i18next';

export const useTranslationHook = () => {
  const { t } = useTranslation([
    'tour',
    'translation',
    'contact',
    'acquire',
    'details',
    'agenda',
    'reports',
  ]);

  //#region General Translation
  const notesString = t('translation:general.notes');
  const colonyString = t('translation:general.colony');
  const cityString = t('translation:general.city');
  const stateString = t('translation:general.state');
  const countryString = t('translation:general.country');
  const jobString = t('translation:general.job');
  //#endregion

  //#region Agenda Translation
  const agendaTechHeader = t('agenda:tech');
  const agendaNoData = t('agenda:noData');
  const agendaToday = t('agenda:today');

  const agendaStatusCanceled = t('agenda:status.canceled');
  const agendaStatusPending = t('agenda:status.pending');
  const agendaStatusOngoing = t('agenda:status.ongoing');
  const agendaStatusFinished = t('agenda:status.finished');
  const agendaStatusRejected = t('agenda:status.rejected');
  const agendaStatusScheduled = t('agenda:status.scheduled');

  const agendaDaySun = t('agenda:days.sun');
  const agendaDayMon = t('agenda:days.mon');
  const agendaDayTue = t('agenda:days.tue');
  const agendaDayWed = t('agenda:days.wed');
  const agendaDayThu = t('agenda:days.thu');
  const agendaDayFri = t('agenda:days.fri');
  const agendaDaySat = t('agenda:days:sat');

  const agendaVisitType = t('agenda:visits.vtype');
  const agendaVisitSite = t('agenda:visits.site');
  const agendaVisitDuration = t('agenda:visits.duration');
  const agendaVisitStatus = t('agenda:visits.status');

  //#endregion

  //#region Details Translation
  const visitsCardIdStr = t('details:visits.card.id');
  const visitsCardDateStr = t('details:visits.card.date');
  const visitsCardSiteStr = t('details:visits.card.site');
  const visitsCardTypeStr = t('details:visits.card.type');
  const visitsCardAddressStr = t('details:visits.card.address');
  const visitsCardAssetStr = t('details:visits.card.asset');
  const visitsCardStatusStr = t('details:visits.card.status');
  const visitsCardTechStr = t('details:visits.card.tech');
  const visitsCardNonAStr = t('details:visits.card.nonassigned');
  const visitsCardSeeMoreStr = t('details:visits.card.seemore');

  const visitsLogsTitleStr = t('details:visits.logs.title');
  const visitsLogsEmptyStr = t('details:visits.logs.empty');

  const visitsActionsTitleStr = t('details:visits.actions.title');
  const visitsActionsAssignStr = t('details:visits.actions.assign');
  const visitsActionsEmptyStr = t('details:visits.actions.empty');

  const visitsReportSDateStr = t('details:visits.report.signature.date');
  const visitsReportSLocStr = t('details:visits.report.signature.location');

  const visitsReportQuestionStr = t('details:visits.report.question');
  const visitsReportAnswerStr = t('details:visits.report.answer');
  const visitsReportTitleStr = t('details:visits.report.title');

  //#endregion

  //#region Acquire Translations
  const mainAcquireStr = t('acquire:main');
  const bodyAcquireStr = t('acquire:body');
  const onlineAcquireMethodStr = t('acquire:method.online');
  const commercialAcquireMethodStr = t('acquire:method.commercial');
  const acquireDialogTitleStr = t('acquire:dialog.title');
  const acquireDialogContentStr = t('acquire:dialog.content');
  const acquireDialogCloseStr = t('acquire:dialog.close');
  //#endregion

  //#region ContactModal Translation

  const contactModalTitle = t('contact:title');
  const contactModalEmail = t('contact:email');
  const contactModalEmailHelp = t('contact:email.help');
  const contactModalSubject = t('contact:subject');
  const contactModalMessage = t('contact:message');
  const contactModalSend = t('contact:send');
  const contactModalTeamT = t('contact:team.tech');
  const contactModalTeamC = t('contact:team.commercial');
  const contactModalAlertS = t('contact:alert.success');
  const contactModalAlertE = t('contact:alert.error');

  //#endregion

  //#region Tour Translations
  const usersS1P1 = t('tour:users.step1.part1');
  const usersS1P2 = t('tour:users.step1.part2');
  const usersS2P1 = t('tour:users.step2.part1');
  const usersS2P2 = t('tour:users.step2.part2');
  const usersS3P1 = t('tour:users.step3.part1');
  const usersS3P2 = t('tour:users.step3.part2');
  const usersS3P3 = t('tour:users.step3.part3');
  const usersS3P4 = t('tour:users.step3.part4');
  const usersS3P5 = t('tour:users.step3.part5');
  const usersS4P1 = t('tour:users.step4.part1');
  const usersS4P2 = t('tour:users.step4.part2');
  const usersS5P1 = t('tour:users.step5.part1');
  const usersS5P2 = t('tour:users.step5.part2');

  const techsS1P1 = t('tour:techs.step1.part1');
  const techsS1P2 = t('tour:techs.step1.part2');
  const techsS2P1 = t('tour:techs.step2.part1');
  const techsS2P2 = t('tour:techs.step2.part2');
  const techsS3P1 = t('tour:techs.step3.part1');
  const techsS3P2 = t('tour:techs.step3.part2');
  const techsS3P3 = t('tour:techs.step3.part3');
  const techsS3P4 = t('tour:techs.step3.part4');
  const techsS3P5 = t('tour:techs.step3.part5');
  const techsS4P1 = t('tour:techs.step4.part1');
  const techsS4P2 = t('tour:techs.step4.part2');
  const techsS5P1 = t('tour:techs.step5.part1');
  const techsS5P2 = t('tour:techs.step5.part2');

  const equipsS1P1 = t('tour:equips.step1.part1');
  const equipsS1P2 = t('tour:equips.step1.part2');
  const equipsS2P1 = t('tour:equips.step2.part1');
  const equipsS2P2 = t('tour:equips.step2.part2');
  const equipsS3P1 = t('tour:equips.step3.part1');
  const equipsS3P2 = t('tour:equips.step3.part2');
  const equipsS3P3 = t('tour:equips.step3.part3');
  const equipsS3P4 = t('tour:equips.step3.part4');
  const equipsS3P5 = t('tour:equips.step3.part5');
  const equipsS4P1 = t('tour:equips.step4.part1');
  const equipsS4P2 = t('tour:equips.step4.part2');
  const equipsS5P1 = t('tour:equips.step5.part1');
  const equipsS5P2 = t('tour:equips.step5.part2');

  const assetsS1P1 = t('tour:assets.step1.part1');
  const assetsS1P2 = t('tour:assets.step1.part2');
  const assetsS2P1 = t('tour:assets.step2.part1');
  const assetsS2P2 = t('tour:assets.step2.part2');
  const assetsS3P1 = t('tour:assets.step3.part1');
  const assetsS3P2 = t('tour:assets.step3.part2');
  const assetsS3P3 = t('tour:assets.step3.part3');
  const assetsS3P4 = t('tour:assets.step3.part4');
  const assetsS3P5 = t('tour:assets.step3.part5');
  const assetsS4P1 = t('tour:assets.step4.part1');
  const assetsS4P2 = t('tour:assets.step4.part2');
  const assetsS5P1 = t('tour:assets.step5.part1');
  const assetsS5P2 = t('tour:assets.step5.part2');

  const clientsS1P1 = t('tour:clients.step1.part1');
  const clientsS1P2 = t('tour:clients.step1.part2');
  const clientsS2P1 = t('tour:clients.step2.part1');
  const clientsS2P2 = t('tour:clients.step2.part2');
  const clientsS3P1 = t('tour:clients.step3.part1');
  const clientsS3P2 = t('tour:clients.step3.part2');
  const clientsS3P3 = t('tour:clients.step3.part3');
  const clientsS3P4 = t('tour:clients.step3.part4');
  const clientsS3P5 = t('tour:clients.step3.part5');
  const clientsS4P1 = t('tour:clients.step4.part1');
  const clientsS5P1 = t('tour:clients.step5.part1');
  const clientsS5P2 = t('tour:clients.step5.part2');
  const clientsS6P1 = t('tour:clients.step6.part1');
  const clientsS6P2 = t('tour:clients.step6.part2');

  const visitsS1P1 = t('tour:visits.step1.part1');
  const visitsS1P2 = t('tour:visits.step1.part2');
  const visitsS2P1 = t('tour:visits.step2.part1');
  const visitsS2P2 = t('tour:visits.step2.part2');
  const visitsS3P1 = t('tour:visits.step3.part1');
  const visitsS3P2 = t('tour:visits.step3.part2');
  const visitsS3P3 = t('tour:visits.step3.part3');
  const visitsS3P4 = t('tour:visits.step3.part4');
  const visitsS3P5 = t('tour:visits.step3.part5');
  const visitsS4P1 = t('tour:visits.step4.part1');
  const visitsS4P2 = t('tour:visits.step4.part2');
  const visitsS5P1 = t('tour:visits.step5.part1');
  const visitsS5P2 = t('tour:visits.step5.part2');

  const clientInfoS1P1 = t('tour:clientInfo.step1.part1');
  const clientInfoS1P2 = t('tour:clientInfo.step1.part2');

  const clientInfoS2P1 = t('tour:clientInfo.step2.part1');
  const clientInfoS2P2 = t('tour:clientInfo.step2.part2');

  const clientInfoS3P1 = t('tour:clientInfo.step3.part1');
  const clientInfoS3P2 = t('tour:clientInfo.step3.part2');
  const clientInfoS3P3 = t('tour:clientInfo.step3.part3');
  const clientInfoS3P4 = t('tour:clientInfo.step3.part4');

  const clientInfoS4P1 = t('tour:clientInfo.step4.part1');
  const clientInfoS4P2 = t('tour:clientInfo.step4.part2');
  const clientInfoS4P3 = t('tour:clientInfo.step4.part3');
  const clientInfoS4P4 = t('tour:clientInfo.step4.part4');
  const clientInfoS4P5 = t('tour:clientInfo.step4.part5');
  const clientInfoS4P6 = t('tour:clientInfo.step4.part6');
  const clientInfoS4P7 = t('tour:clientInfo.step4.part7');

  const clientInfoS5P1 = t('tour:clientInfo.step5.part1');
  const clientInfoS5P2 = t('tour:clientInfo.step5.part2');
  const clientInfoS5P3 = t('tour:clientInfo.step5.part3');
  const clientInfoS5P4 = t('tour:clientInfo.step5.part4');
  const clientInfoS5P5 = t('tour:clientInfo.step5.part5');
  const clientInfoS5P6 = t('tour:clientInfo.step5.part6');
  const clientInfoS5P7 = t('tour:clientInfo.step5.part7');

  const visitsControlS1P1 = t('tour:visitsControl.step1.part1');
  const visitsControlS1P2 = t('tour:visitsControl.step1.part2');

  const visitsControlS2P1 = t('tour:visitsControl.step2.part1');
  const visitsControlS2P2 = t('tour:visitsControl.step2.part2');
  const visitsControlS2P3 = t('tour:visitsControl.step2.part3');

  const visitsControlS3P1 = t('tour:visitsControl.step3.part1');
  const visitsControlS3P2 = t('tour:visitsControl.step3.part2');
  const visitsControlS3P3 = t('tour:visitsControl.step3.part3');

  //#endregion

  //#region General Translation
  const demoMsgP1 = t('translation:demo.msg.part1');
  const demoMsgP2 = t('translation:demo.msg.part2');
  const demoMsgAcquire = t('translation:demo.msg.acquire');
  const versionString = t('translation:version');
  const loadingString = t('translation:loading');
  const phoneCountryStr = t('translation:countryPhone');

  const dashboardString = t('translation:general.dashboard');
  const clientsString = t('translation:general.clients');
  const clientsCRUDStr = t('translation:general.clients.crud');
  const clientsSitesStr = t('translation:general.clients.sites');
  const clientsContactsStr = t('translation:general.clients.contacts');
  const techsString = t('translation:general.techs');
  const techsCRUDStr = t('translation:general.techs.crud');
  const techsHistoryStr = t('translation:general.techs.history');
  const usersString = t('translation:general.users');
  const userString = t('translation:general.user');
  const rolesString = t('translation:general.roles');
  const roleString = t('translation:general.role');
  const visitsString = t('translation:general.visits');
  const visitsCRUDStr = t('translation:general.visits.crud');
  const visitsRejectedStr = t('translation:general.visits.rejected');
  const visitsRejectedPageTitleStr = t(
    'translation:general.visits.rejected.page.title'
  );
  const visitsFollowStr = t('translation:general.visits.follow');
  const equipsString = t('translation:general.equips');
  const itemsString = t('translation:general.items');
  const assetsString = t('translation:general.assets');
  const inventoryString = t('translation:general.inventory');
  const inventoryWarehouseStr = t('translation:general.inventory.warehouse');
  const inventoryWarehouseMStr = t('translation:general.inventory.warehousem');
  const inventoryWarehouseAdmonStr = t(
    'translation:general.inventory.warehouseadmon'
  );
  const inventoryLocationsStr = t('translation:general.inventory.locations');
  const inventoryEntriesExitsStr = t(
    'translation:general.inventory.entriesexits'
  );
  const inventoryManufacturersStr = t(
    'translation:general.inventory.manufacturers'
  );

  const newStr = t('translation:general.new');
  const manufacturerStr = t('translation:general.manufacturer');
  const manufacturerNameStr = t('translation:general.manufacturer.modal.name');
  const manufacturerDescriptionStr = t(
    'translation:general.manufacturer.modal.description'
  );

  const saveStr = t('translation:general.manufacturer.modal.save');

  const manufacturerModalDeleteString = t(
    'translation:general.manufacturer.modal.delete'
  );

  const sitesString = t('translation:general.sites');
  const contactsString = t('translation:general.contacts');
  const settingsString = t('translation:navbar.settings');
  const indicatorsString = t('translation:general.indicators');

  const bcClientInfoString = t('translation:breadcrumb.clientinfo');

  const dashboardViewMapStr = t('translation:dashboard.actions.view.map');
  const dashboardViewVTableStr = t('translation:dashboard.actions.view.vtable');
  const dashboardShowTMarkersStr = t(
    'translation:dashboard.actions.tmarkers.show'
  );
  const dashboardHideTMarkersStr = t(
    'translation:dashboard.actions.tmarkers.hide'
  );

  const dashboardMarkerTech = t('translation:dashboard.marker.techid');
  const dashboardMarkerVisit = t('translation:dashboard.marker.visitid');

  const dashboardDTTechsName = t(
    'translation:dashboard.datagrid.techs.fullname'
  );
  const dashboardDTTechsPhone = t('translation:dashboard.datagrid.techs.phone');

  const dashboardDTTechsTitle = t(
    'translation:dashboard.datagrid.techs.nom.title'
  );
  const dashboardDTTechsO = t('translation:dashboard.datagrid.techs.nom.busy');
  const dashboardDTTechsF = t(
    'translation:dashboard.datagrid.techs.nom.unbusy'
  );
  const dashboardDTTechsD = t(
    'translation:dashboard.datagrid.techs.nom.disconnected'
  );

  const dashboardDTVisitsTitle = t(
    'translation:dashboard.datagrid.visits.nom.title'
  );
  const dashboardDTVisitsClient = t(
    'translation:dashboard.datagrid.visits.client'
  );
  const dashboardDTVisitsSite = t('translation:dashboard.datagrid.visits.site');
  const dashboardDTVisitsVType = t(
    'translation:dashboard.datagrid.visits.vtype'
  );
  const dashboardDTVisitsTech = t('translation:dashboard.datagrid.visits.tech');

  const dashboardDTVisitsVC = t(
    'translation:dashboard.datagrid.visits.nom.completed'
  );
  const dashboardDTVisitsVA = t(
    'translation:dashboard.datagrid.visits.nom.assigned'
  );
  const dashboardDTVisitsVNA = t(
    'translation:dashboard.datagrid.visits.nom.nassigned'
  );
  const dashboardDTVisitsVCa = t(
    'translation:dashboard.datagrid.visits.nom.cancelled'
  );

  const settingsModulesString = t('translation:settings.modules');
  const settingsMQString = t('translation:settings.modules.questionnaires');
  const settingsMVtypesString = t('translation:settings.modules.vtypes');
  const settingsMRString = t('translation:settings.modules.reports');

  const settingsGeneralsString = t('translation:settings.generals');
  const settingsGProfileString = t('translation:settings.generals.profile');
  const settingsGNotifString = t('translation:settings.generals.notifications');
  const settingsGWidgetsString = t('translation:settings.generals.widgets');
  const settingsGThemesString = t('translation:settings.generals.themes');

  const addString = t('translation:add');
  const addVtypeString = t('translation:add.vtype');
  const addQString = t('translation:add.questionnarie');
  const viewQuestionsString = t('translation:view.questions');
  const viewTutorialString = t('translation:view.tutorial');
  const editString = t('translation:edit');
  const deleteString = t('translation:delete');
  const deactivateString = t('translation:deactivate');
  const reactivateString = t('translation:reactivate');
  const activeString = t('translation:Activo');
  const inactiveString = t('translation:Inactivo');
  const moveString = t('translation:move');
  const multDeleteString = t('translation:multdelete');
  const recoverString = t('translation:recover');
  const logsString = t('translation:logs');
  const viewPermsString = t('translation:viewpermissions');
  const dwtemplateString = t('translation:downloadtemplate');
  const dwQResponsesString = t('translation:downloadqresponse');
  const importString = t('translation:importfile');
  const detailString = t('translation:detail');
  const saveString = t('translation:save');
  const saveChangesString = t('translation:savechanges');
  const pwTooltipString = t('translation:pwtooltip');
  const modalYesString = t('translation:modal.delete');
  const modalNoString = t('translation:modal.back.table');
  const backToQString = t('translation:backtoq');
  const swapString = t('translation:selectforswap');
  const clientFilterStr = t('translation:clientfilter');

  const tableClientString = t('translation:dvisits.client');
  const tableSiteString = t('translation:dvisits.site');
  const tableStatusString = t('translation:dvisits.status');
  const tableActionsString = t('translation:dvisits.actions');
  const tableVisitTypeString = t('translation:dvisits.vtype');

  const vTypesNameString = t('translation:settings.vtypes.name');
  const vTypesDescString = t('translation:settings.vtypes.description');
  const vTypesStatusString = t('translation:settings.vtypes.status');

  const vTypesModalCreateString = t('translation:vtypes.modal.create');
  const vTypesMCVtypeString = t('translation:vtypes.modal.create.vtype');
  const vTypesMCDescString = t('translation:vtypes.modal.create.desc');
  const vTypesMCEstimatedTimeString = t(
    'translation:vtypes.modal.create.estimatedTime'
  );

  const vTypesModalDeleteString = t('translation:vtypes.modal.delete');
  const vTypesMDVtypeString = t('translation:vtypes.modal.delete.vtype');
  const vTypesMDDescString = t('translation:vtypes.modal.delete.desc');

  const clientContactNameString = t('translation:clients.contactname');
  const clientClientString = t('translation:clients.client');
  const clientStatusString = t('translation:clients.status');
  const clientCreatedBy = t('translation:clients.createdBy');
  const clientCreatedAt = t('translation:clients.createdAt');
  const clientUpdatedBy = t('translation:clients.updatedBy');
  const clientUpdatedAt = t('translation:clients.updatedAt');

  const clientModalCreateString = t('translation:clients.modal.create');

  const clientMCGeneralString = t('translation:clients.modal.create.general');
  const clientMCGBusinessNString = t(
    'translation:clients.modal.create.general.businessname'
  );
  const clientMCCompanyNameString = t(
    'translation:clients.modal.create.general.companyname'
  );

  const clientMCCCompanyName = t('translation:clients.modal.create.company');
  const clientMCContactString = t('translation:clients.modal.create.contact');
  const clientMCCEmailString = t(
    'translation:clients.modal.create.contact.email'
  );
  const clientMCCNameString = t(
    'translation:clients.modal.create.contact.name'
  );
  const clientMCCLastNameString = t(
    'translation:clients.modal.create.contact.lastname'
  );
  const clientMCCPasswordString = t(
    'translation:clients.modal.create.contact.password'
  );
  const clientMCCRPasswordString = t(
    'translation:clients.modal.create.contact.rpassword'
  );

  const clientModalDeleteString = t('translation:clients.modal.delete');
  const clientMDClientString = t('translation:clients.modal.delete.client');
  const clientMDEDateString = t('translation:clients.modal.delete.edate');

  const clientInfoBNameString = t('translation:clientinfo.businessname');

  const contactContactPosition = t(
    'translation:contacts.modal.create.contact.position'
  );
  const contactContactNameString = t('translation:contacts.contactname');
  const contactEmailString = t('translation:contacts.email');
  const contactPhoneString = t('translation:contacts.phone');
  const contactTypeString = t('translation:contacts.type');
  const contactClientString = t('translation:contacts.client');
  const contactSiteString = t('translation:contacts.site');
  const contactStatusString = t('translation:contacts.status');
  const contactEDateString = t('translation:contacts.edate');

  const contactModalDeleteString = t('translation:contacts.modal.delete');
  const contactMDNameString = t('translation:contacts.modal.delete.name');
  const contactMDEmailString = t('translation:contacts.modal.delete.email');
  const contactMDClientString = t('translation:contacts.modal.delete.client');
  const contactMDEDateString = t('translation:contacts.modal.delete.edate');

  const siteSiteNameString = t('translation:sites.sitename');
  const siteCostCenterString = t('translation:sites.costCenter');
  const siteStreetNameString = t('translation:sites.streetname');
  const siteAddressNumString = t('translation:sites.addressnum');
  const siteMunicipality = t('translation:sites.municipality');
  const sitePCString = t('translation:sites.pc');
  const siteStatusString = t('translation:sites.status');
  const siteEDateString = t('translation:sites.edate');
  const siteUDateString = t('translation:sites.udate');
  const siteCByString = t('translation:sites.cby');
  const siteUByString = t('translation:sites.uby');

  const siteModalDeleteString = t('translation:sites.modal.delete');
  const siteMDSiteNameString = t('translation:sites.modal.delete.sitename');
  const siteMDClientString = t('translation:sites.modal.delete.client');
  const siteMDStreetNameString = t('translation:sites.modal.delete.streetname');
  const siteMDAddressNumString = t('translation:sites.modal.delete.addressnum');
  const siteMDPCString = t('translation:sites.modal.delete.pc');
  const siteMDEDateString = t('translation:sites.modal.delete.edate');

  const techContactNameString = t('translation:techs.contactname');
  const techEmailString = t('translation:techs.email');
  const techPhoneString = t('translation:techs.phone');
  const techBirthDateString = t('translation:techs.birthdate');
  const techEntryDateString = t('translation:techs.entrydate');
  const techStatusString = t('translation:techs.status');
  const techEDateString = t('translation:techs.edate');

  const techModalDeleteString = t('translation:techs.modal.delete');
  const techMDNameString = t('translation:techs.modal.delete.name');
  const techMDEmailString = t('translation:techs.modal.delete.email');
  const techMDPhoneString = t('translation:techs.modal.delete.phone');
  const techMDEDateString = t('translation:techs.modal.delete.edate');

  const techGHHistoryTitle = t(
    'translation:techs.geolocationhistory.history.title'
  );
  const techGHHistorySubtitle = t(
    'translation:techs.geolocationhistory.history.subtitle'
  );
  const techGHHistoryPlaceholder = t(
    'translation:techs.geolocationhistory.history.placeholder'
  );
  const techGHGeolocation = t(
    'translation:techs.geolocationhistory.geolocation'
  );
  const techsGHSCInstruction = t(
    'translation:techs.geolocationhistory.settingscard.instruction'
  );
  const techsGHSCTech = t(
    'translation:techs.geolocationhistory.settingscard.tech'
  );
  const techsGHSCPeriod = t(
    'translation:techs.geolocationhistory.settingscard.period'
  );
  const techsGHSCPStart = t(
    'translation:techs.geolocationhistory.settingscard.period.start'
  );
  const techsGHSCPEnd = t(
    'translation:techs.geolocationhistory.settingscard.period.end'
  );
  const techsGHSCTodayP = t(
    'translation:techs.geolocationhistory.settingscard.todayp'
  );
  const techsGHSCConfirm = t(
    'translation:techs.geolocationhistory.settingscard.confirm'
  );

  const techsGHLLEmpty = t(
    'translation:techs.geolocationhistory.loglist.empty'
  );

  const userFullNameString = t('translation:users.fullname');
  const userEmailString = t('translation:users.email');
  const userStatusString = t('translation:users.status');
  const userEDateString = t('translation:users.edate');

  const userModalDeleteString = t('translation:users.modal.delete');
  const userMDNameString = t('translation:users.modal.delete.name');
  const userMDEmailString = t('translation:users.modal.delete.email');
  const userMDEDateString = t('translation:users.modal.delete.edate');

  const visitSiteString = t('translation:visits.site');
  const visitCountryString = t('translation:visits.country');
  const visitStateString = t('translation:visits.state');
  const visitCityString = t('translation:visits.city');
  const visitTechString = t('translation:visits.tech');
  const visitAssetString = t('translation:visits.asset');
  const visitEquipString = t('translation:visits.equip');
  const visitVisitTypeString = t('translation:visits.vtype');
  const visitVisitDateString = t('translation:visits.vdate');
  const visitStatusString = t('translation:visits.status');
  const visitUDateString = t('translation:visits.udate');
  const visitDescString = t('translation:visits.desc');

  const visitModalDeleteString = t('translation:visits.modal.delete');
  const visitMDSiteString = t('translation:visits.modal.delete.site');
  const visitMDVTypeString = t('translation:visits.modal.delete.vtype');
  const visitMDTechString = t('translation:visits.modal.delete.tech');
  const visitMDUDateString = t('translation:visits.modal.delete.udate');
  const visitMDDateString = t('translation:visits.modal.delete.date');

  const equipNameString = t('translation:equips.name');
  const equipBrandString = t('translation:equips.brand');
  const equipStatusString = t('translation:equips.status');
  const equipModelString = t('translation:equips.model');
  const equipUDateString = t('translation:equips.udate');
  const equipValueString = t('translation:equip.value');
  const equipCapacityString = t('translation:equip.capacity');

  const equipMCTitle = t('translation:equips.modal.create.title');
  const equipMDescString = t('translation:equips.modal.create.desc');
  const equipModalDeleteString = t('translation:equips.modal.delete');
  const equipMDNameString = t('translation:equips.modal.delete.name');
  const equipMDBrandString = t('translation:equips.modal.delete.brand');
  const equipMDUDateString = t('translation:equips.modal.delete.udate');

  const itemNameString = t('translation:items.name');
  const itemCurrencyString = t('translation:items.currency');
  const itemUnitString = t('translation:items.unit');
  const itemStatusString = t('translation:items.status');
  const itemUDateString = t('translation:items.udate');

  const itemModalDeleteString = t('translation:items.modal.delete');
  const itemMDNameString = t('translation:items.modal.delete.name');
  const itemMDCurrencyString = t('translation:items.modal.delete.currency');
  const itemMDUnitString = t('translation:items.modal.delete.unit');
  const itemMDUDateString = t('translation:items.modal.delete.udate');

  const assetNameString = t('translation:assets.name');
  const assetEquipString = t('translation:assets.equip');
  const assetSerialNumberStr = t('translation:assets.serialnumber');
  const assetClientString = t('translation:assets.client');
  const assetSiteString = t('translation:assets.site');
  const assetLocationString = t('translation:assets.location');
  const assetStatusString = t('translation:assets.status');
  const assetUDateString = t('translation:assets.udate');

  const assetModalDeleteString = t('translation:assets.modal.delete');
  const assetMDNameString = t('translation:assets.modal.delete.name');
  const assetMDEquipString = t('translation:assets.modal.delete.equip');
  const assetMDSiteString = t('translation:assets.modal.delete.site');
  const assetMDUDateString = t('translation:assets.modal.delete.udate');

  const questionnarieQNameString = t('translation:questionnaries.qname');
  const questionnarieQDescriptionString = t(
    'translation:questionnaries.description'
  );
  const questionnarieQVTypeString = t('translation:questionnaries.vtype');

  const qQuestionsAddQString = t(
    'translation:questionnaires.questions.addquestion'
  );
  const qQuestionsAddMString = t(
    'translation:questionnaires.questions.addmessage'
  );
  const qQuestionsAddTitleString = t(
    'translation:questionnaires.questions.addtitle'
  );
  const qQuestionsAddLoopString = t(
    'translation:questionnaires.questions.addloop'
  );
  const qQuestionsAddIfString = t('translation:questionnaires.questions.addif');
  const qQuestionsAddTableString = t(
    'translation:questionnaires.questions.addtable'
  );
  const qQuestionsConfirmString = t(
    'translation:questionnaires.questions.confirm'
  );
  const qQuestionsDiscardString = t(
    'translation:questionnaires.questions.discard'
  );
  const qQuestionsMultDeleteString = t(
    'translation:questionnaires.questions.multdelete'
  );

  const qQuestionsConfirmInfoStr = t(
    'translation:questionnaires.questions.confirm.info'
  );

  const questionsQuestionString = t(
    'translation:questionnaires.questions.question'
  );
  const questionsQTypeString = t(
    'translation:questionnaires.questions.questiontype'
  );
  const questionsRTypeString = t(
    'translation:questionnaires.questions.qresponsetype'
  );

  const qModalCreateString = t('translation:questionnaries.modal.create');
  const qModalCreateQNameString = t(
    'translation:questionnaries.modal.create.qname'
  );
  const qModalCreateQDescString = t(
    'translation:questionnaries.modal.create.description'
  );
  const qModalCreateQVTypeString = t(
    'translation:questionnaries.modal.create.vtype'
  );

  const qModalDeleteString = t('translation:questionnaries.modal.delete');
  const qModalDeleteQNameString = t(
    'translation:questionnaries.modal.delete.qname'
  );
  const qModalDeleteQDescString = t(
    'translation:questionnaries.modal.delete.description'
  );

  const rModalCreateString = t('translation:reports.modal.create');
  const rModalCreateQNameString = t('translation:reports.modal.create.rname');
  const rModalCreateQDescString = t(
    'translation:reports.modal.create.description'
  );

  const questionModalCreateString = t('translation:questions.modal.create');
  const questionMCQuestionString = t(
    'translation:questions.modal.create.question'
  );
  const questionMCDescString = t(
    'translation:questions.modal.create.questiondesc'
  );
  const questionMCPlaceholderString = t(
    'translation:questions.modal.create.placeholder'
  );
  const questionMCMinRepeatString = t(
    'translation:questions.modal.create.minrepeat'
  );
  const questionMCMaxRepeatString = t(
    'translation:questions.modal.create.maxrepeat'
  );
  const questionMCQTypeString = t(
    'translation:questions.modal.create.questiontype'
  );
  const questionMCRTypeString = t(
    'translation:questions.modal.create.responsetype'
  );
  const questionMCTableString = t('translation:questions.modal.create.table');
  const questionMCOptionsString = t(
    'translation:questions.modal.create.options'
  );

  const questionModalDeleteString = t('translation:questions.modal.delete');
  const questionMDQuestionString = t(
    'translation:questions.modal.delete.question'
  );
  const questionMDQTypeString = t(
    'translation:questions.modal.delete.questiontype'
  );
  const questionMDRTypeString = t(
    'translation:questions.modal.delete.responsetype'
  );

  const questionModalMessageString = t('translation:questions.modal.message');
  const questionModalMTextString = t(
    'translation:questions.modal.message.content'
  );

  const questionModalLoopString = t('translation:questions.modal.loop');

  const questionModalCondString = t('translation:questions.modal.if');
  const questionModalCMainString = t('translation:questions.modal.if.main');
  const questionModalCConditionString = t(
    'translation:questions.modal.if.condition'
  );
  const questionModalCOperationString = t(
    'translation:questions.modal.if.operation'
  );
  const questionModalCExpressionString = t(
    'translation:questions.modal.if.expression'
  );
  const questionModalCThenString = t('translation:questions.modal.if.then');
  const questionModalCThenTextString = t(
    'translation:questions.modal.if.then.text'
  );
  const questionModalCElseString = t('translation:questions.modal.if.else');
  const questionModalCElseTextString = t(
    'translation:questions.modal.if.else.text'
  );

  const questionModalTitleString = t('translation:questions.modal.title');
  const questionModalTTextString = t('translation:questions.modal.title.text');
  const questionModalTColumnsString = t(
    'translation:questions.modal.title.columns'
  );
  const questionModalTColumnsTooltip = t(
    'translation:questions.modal.title.columns.tooltip'
  );

  const questionModalTableString = t('translation:questions.modal.table');
  const questionModalTNameString = t('translation:questions.modal.table.name');

  const noVtypesString = t('translation:datagrid.novtypes');
  const noVisitsString = t('translation:datagrid.novisits');
  const noClientsString = t('translation:datagrid.noclients');
  const noTechsString = t('translation:datagrid.notechs');
  const noVisitsTechNAString = t('translation:datagrid.techna');
  const noUsersString = t('translation:datagrid.nousers');
  const noEquipsString = t('translation:datagrid.noequips');
  const noItemsString = t('translation:datagrid.noitems');
  const noAssetsString = t('translation:datagrid.noassets');
  const noQuestionnariesString = t('translation:datagrid.noquestionnaries');
  const noQuestionsString = t('translation:datagrid.noquestions');
  const noContactsString = t('translation:datagrid.nocontacts');
  const noSitesString = t('translation:datagrid.nosites');
  const noSClientsContacts = t('translation:datagrid.contacts.nonselectedc');
  const noSClientsSites = t('translation:datagrid.sites.nonselectedc');

  const titleDashboardString = t('translation:title.dashboard');
  const titleClientsString = t('translation:title.clients');
  const titleSitesString = t('translation:title.sites');
  const titleContactsString = t('translation:title.contacts');
  const titleUsersString = t('translation:title.users');
  const titleTechsString = t('translation:title.techs');
  const titleVisitsString = t('translation:title.visits');
  const titleEquipsString = t('translation:title.equip');
  const titleItemsString = t('translation:title.item');
  const titleAssetsString = t('translation:title.assets');
  const titleInventoryString = t('translation:title.inventory');
  const titleConfigString = t('translation:title.config');
  const titleTutorialsString = t('translation:title.tutorials');
  const titleNonAuthString = t('translation:title.nonauth');
  const titleNonPermString = t('translation:title.nonperm');

  const isRequiredString = t('translation:isrequired');
  const isRepeatableString = t('translation:isrepeatable');
  const hasLimitString = t('translation:hasLimit');

  const questionTypeTextfield = t('translation:question.type.texfield');
  const questionTypeNumeric = t('translation:question.type.numeric');
  const questionTypeDropbox = t('translation:question.type.dropbox');
  const questionTypePhoto = t('translation:question.type.photo');
  const questionTypeSection = t('translation:question.type.section');
  const questionTypeMessage = t('translation:question.type.message');
  const questionTypeDateTime = t('translation:question.type.datetime');

  const answerTypeText = t('translation:answer.type.text');
  const answerTypeLongText = t('translation:answer.type.longText');
  const answerTypeNumber = t('translation:answer.type.number');
  const answerTypeDecimal = t('translation:answer.type.decimal');
  const answerTypePercentage = t('translation:answer.type.percentage');
  const answerTypeCurrency = t('translation:answer.type.currency');
  const answerTypeTable = t('translation:answer.type.table');
  const answerTypeMultipleOption = t('translation:answer.type.multipleOption');
  const answerTypeFile = t('translation:answer.type.file');
  const answerTypeCamera = t('translation:answer.type.camera');
  const answerTypeGallery = t('translation:answer.type.gallery');
  const answerTypeNA = t('translation:answer.type.na');
  const answerTypeDate = t('translation:answer.type.date');
  const answerTypeTime = t('translation:answer.type.time');

  const nameString = t('translation:name');
  const statusString = t('translation:status');
  const descriptionString = t('translation:description');
  const createdAtString = t('translation:created.at');
  const createdByString = t('translation:created.by');
  const updatedAtString = t('translation:updated.at');
  const updatedByString = t('translation:updated.by');

  const alertClientCreateS = t('translation:alerts.clients.create.success');
  const alertClientCreateE = t('translation:alerts.clients.create.error');
  const alertClientCreatePWE = t('translation:alerts.clients.create.pwerror');
  const alertClientCreateWPWE = t(
    'translation:alerts.clients.create.weakpwerror'
  );
  const alertClientCreateCE = t(
    'translation:alerts.clients.create.clienterror'
  );
  const alertClientCreateUE = t(
    'translation:translation:alerts.clients.create.usererror'
  );
  const alertClientUpdateS = t(
    'translation:translation:alerts.clients.update.success'
  );
  const alertClientUpdateE = t('translation::alerts.clients.update.error');
  const alertClientUpdateCE = t(
    'translation:alerts.clients.update.clienterror'
  );
  const alertClientDeleteS = t('translation:alerts.clients.delete.success');
  const alertClientDeleteE = t('translation:alerts.clients.delete.error');
  const alertClientMDeleteS = t(
    'translation:alerts.clients.multdelete.success'
  );
  const alertClientMDeleteE = t('translation:alerts.clients.multdelete.error');
  const alertClientImportS = t('translation:alerts.clients.import.success');
  const alertClientImportE = t('translation:alerts.clients.import.error');

  const alertTechCreateS = t('translation:');
  const alertTechCreateE = t('translation:');
  const alertTechCreatePWE = t('translation:');
  const alertTechCreateWPWE = t('translation:');
  const alertTechCreateTE = t('translation:');
  const alertTechCreateDE = t('translation:');
  const alertTechUpdateS = t('translation:');
  const alertTechUpdateE = t('translation:');
  const alertTechUpdateTE = t('translation:');
  const alertTechUpdateDE = t('translation:');
  const alertTechDeleteS = t('translation:');
  const alertTechDeleteE = t('translation:');
  const alertTechMDeleteS = t('translation:');
  const alertTechMDeleteE = t('translation:');
  const alertTechImportS = t('translation:');
  const alertTechImportE = t('translation:');

  const alertUserCreateS = t('translation:');
  const alertUserCreateE = t('translation:');
  const alertUserCreatePWE = t('translation:');
  const alertUserCreateWPWE = t('translation:');
  const alertUserCreateUE = t('translation:');
  const alertUserUpdateS = t('translation:');
  const alertUserUpdateE = t('translation:');
  const alertUserUpdatePWE = t('translation:');
  const alertUserUpdateWPWE = t('translation:');
  const alertUserUpdateUE = t('translation:');
  const alertUserDeleteS = t('translation:');
  const alertUserDeleteE = t('translation:');
  const alertUserMDeleteS = t('translation:');
  const alertUserMDeleteE = t('translation:');
  const alertUserImportS = t('translation:');
  const alertUserImportE = t('translation:');

  const alertVisitCreateS = t('translation:');
  const alertVisitCreateE = t('translation:');
  const alertVisitUpdateS = t('translation:');
  const alertVisitUpdateE = t('translation:');
  const alertVisitDeleteS = t('translation:');
  const alertVisitDeleteE = t('translation:');
  const alertVisitMDeleteS = t('translation:');
  const alertVisitMDeleteE = t('translation:');
  const alertVisitImportS = t('translation:');
  const alertVisitImportE = t('translation:');

  const alertCContactCreateS = t('translation:');
  const alertCContactCreateE = t('translation:');
  const alertCContactCreatePWE = t('translation:');
  const alertCContactCreateWPWE = t('translation:');
  const alertCContactCreateUE = t('translation:');
  const alertCContactUpdateS = t('translation:');
  const alertCContactUpdateE = t('translation:');
  const alertCContactUpdatePWE = t('translation:');
  const alertCContactUpdateWPWE = t('translation:');
  const alertCContactUpdateUE = t('translation:');
  const alertCContactDeleteS = t('translation:');
  const alertCContactDeleteE = t('translation:');

  const alertSiteCreateS = t('translation:');
  const alertSiteCreateE = t('translation:');
  const alertSiteUpdateS = t('translation:');
  const alertSiteUpdateE = t('translation:');
  const alertSiteDeleteS = t('translation:');
  const alertSiteDeleteE = t('translation:');
  const alertSiteMDeleteS = t('translation:');
  const alertSiteMDeleteE = t('translation:');
  const alertSiteImportS = t('translation:');
  const alertSiteImportE = t('translation:');

  const alertAllQCreateS = t('translation:');
  const alertAllQCreateE = t('translation:');
  const alertAllQUpdateS = t('translation:');
  const alertAllQUpdateE = t('translation:');
  const alertAllQDeleteS = t('translation:');
  const alertAllQDeleteE = t('translation:');

  const alertQuestionCreateS = t('translation:');
  const alertQuestionCreateE = t('translation:');
  const alertMessageCreateS = t('translation:');
  const alertMessageCreateE = t('translation:');
  const alertTableCreateS = t('translation:');
  const alertTableCreateE = t('translation:');
  const alertTitleCreateS = t('translation:');
  const alertTitleCreateE = t('translation:');
  const alertCondCreateS = t('translation:');
  const alertCondCreateE = t('translation:');
  const alertQuestionDeleteS = t('translation:');
  const alertQuestionDeleteE = t('translation:');
  const alertQuestionMDeleteS = t('translation:');
  const alertQuestionMDeleteE = t('translation:');

  const alertVTypeCreateS = t('translation:');
  const alertVTypeCreateE = t('translation:');
  const alertVTypeUpdateS = t('translation:');
  const alertVTypeUpdateE = t('translation:');
  const alertVTypeDeleteS = t('translation:');
  const alertVTypeDeleteE = t('translation:');

  //#endregion

  //#region Reports Translation
  const viewReportsTooltip = t('reports:tooltips.view.reports');
  const viewReportTooltip = t('reports:tooltips.view.report');
  const addReportBtn = t('reports:buttons.add');
  const noReportsLabel = t('reports:labels.noreports');
  const reportNameColumn = t('reports:columns.name');
  const reportDescColumn = t('reports:columns.desc');

  const builderDSave = t('reports:builder.designer.save');
  const builderDSelectBasePdf = t('reports:builder.designer.selectbasepdf');
  const builderDAddPage = t('reports:builder.designer.addpage');
  const builderDRemovePage = t('reports:builder.designer.addpage');
  const builderDClearBasePdf = t('reports:builder.designer.clearbasepdf');
  const builderDAlertS = t('reports:builder.designer.alerts.success');
  const builderDAlertE = t('reports:builder.designer.alerts.error');
  const builderVAlertS = t('reports:builder.viewer.alerts.success');
  const builderVAlertE = t('reports:builder.viewer.alerts.error');
  //#endregion

  return {
    //#region General Translation
    notesString,
    colonyString,
    cityString,
    stateString,
    countryString,
    jobString,
    //#endregion

    //#region Agenda Translation
    agendaTechHeader,
    agendaNoData,
    agendaToday,
    agendaStatusCanceled,
    agendaStatusPending,
    agendaStatusOngoing,
    agendaStatusFinished,
    agendaStatusRejected,
    agendaStatusScheduled,
    agendaDaySun,
    agendaDayMon,
    agendaDayTue,
    agendaDayWed,
    agendaDayThu,
    agendaDayFri,
    agendaDaySat,
    agendaVisitType,
    agendaVisitSite,
    agendaVisitDuration,
    agendaVisitStatus,
    //#endregion

    //#region Details Translation
    visitsCardIdStr,
    visitsCardDateStr,
    visitsCardSiteStr,
    visitsCardTypeStr,
    visitsCardAddressStr,
    visitsCardAssetStr,
    visitsCardStatusStr,
    visitsCardTechStr,
    visitsCardNonAStr,
    visitsCardSeeMoreStr,
    visitsLogsTitleStr,
    visitsLogsEmptyStr,
    visitsActionsTitleStr,
    visitsActionsAssignStr,
    visitsActionsEmptyStr,
    visitsReportSDateStr,
    visitsReportSLocStr,
    visitsReportQuestionStr,
    visitsReportAnswerStr,
    visitsReportTitleStr,
    //#endregion

    //#region Acquire Translation
    mainAcquireStr,
    bodyAcquireStr,
    onlineAcquireMethodStr,
    commercialAcquireMethodStr,
    acquireDialogTitleStr,
    acquireDialogContentStr,
    acquireDialogCloseStr,
    //#endregion

    //#region ContactModal Translation
    contactModalTitle,
    contactModalEmail,
    contactModalEmailHelp,
    contactModalSubject,
    contactModalMessage,
    contactModalSend,
    contactModalTeamT,
    contactModalTeamC,
    contactModalAlertS,
    contactModalAlertE,
    //#endregion

    //#region Tour Translations
    usersS1P1,
    usersS1P2,
    usersS2P1,
    usersS2P2,
    usersS3P1,
    usersS3P2,
    usersS3P3,
    usersS3P4,
    usersS3P5,
    usersS4P1,
    usersS4P2,
    usersS5P1,
    usersS5P2,

    techsS1P1,
    techsS1P2,
    techsS2P1,
    techsS2P2,
    techsS3P1,
    techsS3P2,
    techsS3P3,
    techsS3P4,
    techsS3P5,
    techsS4P1,
    techsS4P2,
    techsS5P1,
    techsS5P2,

    equipsS1P1,
    equipsS1P2,
    equipsS2P1,
    equipsS2P2,
    equipsS3P1,
    equipsS3P2,
    equipsS3P3,
    equipsS3P4,
    equipsS3P5,
    equipsS4P1,
    equipsS4P2,
    equipsS5P1,
    equipsS5P2,

    assetsS1P1,
    assetsS1P2,
    assetsS2P1,
    assetsS2P2,
    assetsS3P1,
    assetsS3P2,
    assetsS3P3,
    assetsS3P4,
    assetsS3P5,
    assetsS4P1,
    assetsS4P2,
    assetsS5P1,
    assetsS5P2,

    clientsS1P1,
    clientsS1P2,
    clientsS2P1,
    clientsS2P2,
    clientsS3P1,
    clientsS3P2,
    clientsS3P3,
    clientsS3P4,
    clientsS3P5,
    clientsS4P1,
    clientsS5P1,
    clientsS5P2,
    clientsS6P1,
    clientsS6P2,

    visitsS1P1,
    visitsS1P2,
    visitsS2P1,
    visitsS2P2,
    visitsS3P1,
    visitsS3P2,
    visitsS3P3,
    visitsS3P4,
    visitsS3P5,
    visitsS4P1,
    visitsS4P2,
    visitsS5P1,
    visitsS5P2,

    clientInfoS1P1,
    clientInfoS1P2,

    clientInfoS2P1,
    clientInfoS2P2,

    clientInfoS3P1,
    clientInfoS3P2,
    clientInfoS3P3,
    clientInfoS3P4,

    clientInfoS4P1,
    clientInfoS4P2,
    clientInfoS4P3,
    clientInfoS4P4,
    clientInfoS4P5,
    clientInfoS4P6,
    clientInfoS4P7,

    clientInfoS5P1,
    clientInfoS5P2,
    clientInfoS5P3,
    clientInfoS5P4,
    clientInfoS5P5,
    clientInfoS5P6,
    clientInfoS5P7,

    visitsControlS1P1,
    visitsControlS1P2,
    visitsControlS2P1,
    visitsControlS2P2,
    visitsControlS2P3,
    visitsControlS3P1,
    visitsControlS3P2,
    visitsControlS3P3,

    //#endregion

    //#region General Translation
    demoMsgP1,
    demoMsgP2,
    demoMsgAcquire,
    versionString,
    phoneCountryStr,

    bcClientInfoString,

    settingsString,

    dashboardViewMapStr,
    dashboardViewVTableStr,
    dashboardShowTMarkersStr,
    dashboardHideTMarkersStr,

    dashboardMarkerTech,
    dashboardMarkerVisit,

    dashboardDTTechsName,
    dashboardDTTechsPhone,
    noVisitsTechNAString,
    dashboardDTVisitsClient,
    dashboardDTVisitsSite,
    dashboardDTVisitsVType,
    dashboardDTVisitsTech,

    dashboardDTTechsO,
    dashboardDTTechsF,
    dashboardDTTechsD,

    dashboardDTVisitsVC,
    dashboardDTVisitsVA,
    dashboardDTVisitsVNA,
    dashboardDTVisitsVCa,

    dashboardDTTechsTitle,
    dashboardDTVisitsTitle,

    tableClientString,
    tableSiteString,
    tableStatusString,
    tableActionsString,
    tableVisitTypeString,
    loadingString,
    noVisitsString,

    vTypesNameString,
    vTypesDescString,
    vTypesStatusString,
    noVtypesString,

    vTypesModalCreateString,
    vTypesMCVtypeString,
    vTypesMCDescString,
    vTypesMCEstimatedTimeString,

    vTypesModalDeleteString,
    vTypesMDVtypeString,
    vTypesMDDescString,

    clientContactNameString,
    clientClientString,
    clientStatusString,
    clientCreatedBy,
    clientCreatedAt,
    clientUpdatedBy,
    clientUpdatedAt,
    noClientsString,

    clientModalCreateString,
    clientMCGeneralString,
    clientMCGBusinessNString,
    clientMCCompanyNameString,
    clientMCContactString,
    clientMCCEmailString,
    clientMCCNameString,
    clientMCCLastNameString,
    clientMCCPasswordString,
    clientMCCRPasswordString,

    clientModalDeleteString,
    clientMDClientString,
    clientMDEDateString,

    clientInfoBNameString,

    contactContactPosition,
    contactContactNameString,
    contactEmailString,
    contactPhoneString,
    contactTypeString,
    contactClientString,
    contactSiteString,
    contactStatusString,
    contactEDateString,
    noContactsString,
    noSClientsContacts,

    contactModalDeleteString,
    contactMDNameString,
    contactMDEmailString,
    contactMDClientString,
    contactMDEDateString,

    siteSiteNameString,
    siteCostCenterString,
    siteStreetNameString,
    siteAddressNumString,
    siteMunicipality,
    sitePCString,
    siteStatusString,
    siteEDateString,
    siteUDateString,
    siteCByString,
    siteUByString,
    noSitesString,
    noSClientsSites,

    siteModalDeleteString,
    siteMDSiteNameString,
    siteMDClientString,
    siteMDStreetNameString,
    siteMDAddressNumString,
    siteMDPCString,
    siteMDEDateString,

    techContactNameString,
    techEmailString,
    techPhoneString,
    techBirthDateString,
    techEntryDateString,
    techStatusString,
    techEDateString,
    noTechsString,

    techModalDeleteString,
    techMDNameString,
    techMDEmailString,
    techMDPhoneString,
    techMDEDateString,

    techGHHistoryTitle,
    techGHHistorySubtitle,
    techGHHistoryPlaceholder,
    techGHGeolocation,
    techsGHSCInstruction,
    techsGHSCTech,
    techsGHSCPeriod,
    techsGHSCPStart,
    techsGHSCPEnd,
    techsGHSCTodayP,
    techsGHSCConfirm,
    techsGHLLEmpty,

    userFullNameString,
    userEmailString,
    userStatusString,
    userEDateString,
    noUsersString,

    userModalDeleteString,
    userMDNameString,
    userMDEmailString,
    userMDEDateString,

    visitSiteString,
    visitCountryString,
    visitStateString,
    visitCityString,
    visitTechString,
    visitAssetString,
    visitEquipString,
    visitVisitTypeString,
    visitVisitDateString,
    visitStatusString,
    visitUDateString,
    visitDescString,

    visitModalDeleteString,
    visitMDSiteString,
    visitMDVTypeString,
    visitMDTechString,
    visitMDUDateString,
    visitMDDateString,

    equipNameString,
    equipBrandString,
    equipStatusString,
    equipModelString,
    equipUDateString,
    equipValueString,
    equipCapacityString,
    noEquipsString,

    equipMCTitle,
    equipMDescString,
    equipModalDeleteString,
    equipMDNameString,
    equipMDBrandString,
    equipMDUDateString,

    itemNameString,
    itemCurrencyString,
    itemUnitString,
    itemStatusString,
    itemUDateString,
    noItemsString,

    itemModalDeleteString,
    itemMDNameString,
    itemMDCurrencyString,
    itemMDUnitString,
    itemMDUDateString,

    assetNameString,
    assetEquipString,
    assetSiteString,
    assetStatusString,
    assetUDateString,
    assetSerialNumberStr,
    assetClientString,
    assetLocationString,
    noAssetsString,

    assetModalDeleteString,
    assetMDNameString,
    assetMDEquipString,
    assetMDSiteString,
    assetMDUDateString,

    questionnarieQNameString,
    questionnarieQDescriptionString,
    questionnarieQVTypeString,
    noQuestionnariesString,

    qQuestionsAddQString,
    qQuestionsAddMString,
    qQuestionsAddLoopString,
    qQuestionsAddIfString,
    qQuestionsAddTitleString,
    qQuestionsAddTableString,
    qQuestionsConfirmString,
    qQuestionsDiscardString,
    qQuestionsConfirmInfoStr,
    qQuestionsMultDeleteString,

    rModalCreateString,
    rModalCreateQNameString,
    rModalCreateQDescString,

    questionsQuestionString,
    questionsQTypeString,
    questionsRTypeString,
    noQuestionsString,

    qModalCreateString,
    qModalCreateQNameString,
    qModalCreateQDescString,
    qModalCreateQVTypeString,

    qModalDeleteString,
    qModalDeleteQNameString,
    qModalDeleteQDescString,

    questionModalCreateString,
    questionMCQuestionString,
    questionMCDescString,
    questionMCPlaceholderString,
    questionMCMinRepeatString,
    questionMCMaxRepeatString,
    questionMCQTypeString,
    questionMCRTypeString,
    questionMCTableString,
    questionMCOptionsString,

    questionModalDeleteString,
    questionMDQuestionString,
    questionMDQTypeString,
    questionMDRTypeString,

    questionModalMessageString,
    questionModalMTextString,

    questionModalLoopString,

    questionModalCondString,
    questionModalCMainString,
    questionModalCConditionString,
    questionModalCOperationString,
    questionModalCExpressionString,
    questionModalCThenString,
    questionModalCThenTextString,
    questionModalCElseString,
    questionModalCElseTextString,

    questionModalTitleString,
    questionModalTTextString,
    questionModalTColumnsString,
    questionModalTColumnsTooltip,

    questionModalTableString,
    questionModalTNameString,

    addString,
    addVtypeString,
    addQString,
    viewQuestionsString,
    viewTutorialString,
    editString,
    deleteString,
    deactivateString,
    reactivateString,
    activeString,
    inactiveString,
    moveString,
    multDeleteString,
    recoverString,
    logsString,
    viewPermsString,
    dwtemplateString,
    dwQResponsesString,
    importString,
    detailString,
    saveString,
    saveChangesString,
    pwTooltipString,
    modalYesString,
    modalNoString,
    backToQString,
    swapString,
    clientFilterStr,

    dashboardString,
    clientsString,
    clientsCRUDStr,
    clientsSitesStr,
    clientsContactsStr,
    techsString,
    techsCRUDStr,
    techsHistoryStr,
    usersString,
    userString,
    rolesString,
    roleString,
    visitsString,
    visitsCRUDStr,
    visitsRejectedStr,
    visitsRejectedPageTitleStr,
    visitsFollowStr,
    equipsString,
    itemsString,
    indicatorsString,
    assetsString,
    inventoryString,
    inventoryWarehouseStr,
    inventoryWarehouseMStr,
    inventoryWarehouseAdmonStr,
    inventoryLocationsStr,
    inventoryEntriesExitsStr,
    inventoryManufacturersStr,
    sitesString,
    contactsString,

    newStr,
    manufacturerStr,
    manufacturerNameStr,
    manufacturerDescriptionStr,

    saveStr,

    manufacturerModalDeleteString,

    settingsModulesString,
    settingsMQString,
    settingsMVtypesString,
    settingsMRString,
    settingsGeneralsString,
    settingsGProfileString,
    settingsGNotifString,
    settingsGWidgetsString,
    settingsGThemesString,

    titleDashboardString,
    titleClientsString,
    titleSitesString,
    titleContactsString,
    titleUsersString,
    titleTechsString,
    titleVisitsString,
    titleEquipsString,
    titleItemsString,
    titleAssetsString,
    titleInventoryString,
    titleConfigString,
    titleTutorialsString,
    titleNonAuthString,
    titleNonPermString,

    isRequiredString,
    isRepeatableString,
    hasLimitString,

    questionTypeTextfield,
    questionTypeNumeric,
    questionTypeDropbox,
    questionTypePhoto,
    questionTypeSection,
    questionTypeMessage,
    questionTypeDateTime,

    answerTypeText,
    answerTypeLongText,
    answerTypeNumber,
    answerTypeDecimal,
    answerTypePercentage,
    answerTypeCurrency,
    answerTypeTable,
    answerTypeMultipleOption,
    answerTypeFile,
    answerTypeCamera,
    answerTypeGallery,
    answerTypeNA,
    answerTypeDate,
    answerTypeTime,

    notesString,
    colonyString,
    cityString,
    stateString,
    countryString,
    jobString,

    nameString,
    statusString,
    descriptionString,
    createdAtString,
    createdByString,
    updatedAtString,
    updatedByString,
    //#endregion

    //#region Reports Translation
    viewReportsTooltip,
    viewReportTooltip,
    addReportBtn,
    reportNameColumn,
    reportDescColumn,
    noReportsLabel,
    builderDSave,
    builderDSelectBasePdf,
    builderDAddPage,
    builderDRemovePage,
    builderDClearBasePdf,
    builderDAlertS,
    builderDAlertE,
    builderVAlertS,
    builderVAlertE,
    //#endregion
  };
};
